import * as React from "react";

import "./cart-conflict-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {DeprecatedModalService2}   from "@Common/ui-components/heavy/common/design2/modal-service/modal-service";

export const CartConflictModal = ({templateApprovalRequired, cartApprovalRequired, allowUserPayBypass, next: rootNext}) => cs(
    ["modal", ({}, next) => <DeprecatedModalService2 {...{
        render: ({legacyXpressoConflict, onSelect}, rm) => ({
            content: next({
                legacyXpressoConflict,
                onSelect: (result) => {
                    onSelect(result);
                },
                close: () => rm(),
            }),
        }),
        next: rootNext,
    }}/>],
    consumeContext("themeScheme"),
    ({modal: {legacyXpressoConflict, onSelect, close}, themeScheme}) => (
        <div className="emulation-modal-1sr">
            <div className="title" style={{color: themeScheme.xpresso.menuBackgroundColor}}>
                Conflicting Order(s) in Your Cart!
            </div>

            {cartApprovalRequired ? (
                <div className="msg-1">
                    The order in your cart requires approval and must be checked out alone. 
                    Before you proceed with customizing this order, please complete checkout of the order currently in your cart.
                </div>
            ) : templateApprovalRequired ? (
                <div className="msg-1">
                    The template you’re selecting requires approval and must be checked out alone. 
                    Before you proceed with customizing this order, please complete checkout of the order currently in your cart.
                </div>
            ) : (
                <div className="msg-1">
                    There is a conflict in your cart. Before you proceed with customizing this order,
                    please complete checkout of the orders currently in your cart.
                </div>
            )}

            <div className="buttons">
                <button
                    xd-qa-type="button"
                    xd-qa-name="CHECKOUT MY EXISTING CART"
                    onClick={async () => {
                        onSelect(true);
                        close();
                    }}
                >
                    CHECKOUT MY EXISTING CART
                </button>
            </div>


            <div className="msg-2">
                Not quite ready to checkout your existing orders?
            </div>
            <div className="msg-3">
                <a
                    xd-qa-type="link"
                    xd-qa-name="MOVE CART ORDERS TO PENDING"
                    onClick={async () => {
                        onSelect(false);
                        close();
                    }}
                >MOVE CART ORDERS TO PENDING</a>{" "}
                to begin customizing this product
                {allowUserPayBypass && !legacyXpressoConflict && (
                    <>
                        <br /><b>OR</b><br />
                        <a 
                            xd-qa-type="link"
                            onClick={async () => {
                                onSelect("bypass");
                                close();
                            }}
                        >Click here if you will <b>NOT</b> be using a billing account</a>{" "}
                        for checkout and orders should not require approval.
                    </>
                )}
            </div>

        </div>
    ),
);
